/**
 * Minimum interval between scans when qty === 'boolean'.
 * This guards against accidental double scans from barcode readers and/or Animal Techs not following SOP.
 */
export const timeoutDuration = 20000 // 20s
